import React from 'react';
import { motion } from 'framer-motion';

const MotionSection = ({ 
  children, 
  className = '', 
  delay = 0,
  ...props 
}) => {
  return (
    <motion.section
      initial={{ 
        opacity: 0, 
        y: 24, 
        filter: 'blur(6px)' 
      }}
      whileInView={{ 
        opacity: 1, 
        y: 0, 
        filter: 'blur(0px)' 
      }}
      transition={{ 
        duration: 0.6, 
        ease: 'easeOut',
        delay 
      }}
      viewport={{ 
        once: true, 
        amount: 0.25 
      }}
      className={className}
      {...props}
    >
      {children}
    </motion.section>
  );
};

export default MotionSection;